import { render, staticRenderFns } from "./InventarioItems.vue?vue&type=template&id=7fc0bfb9&scoped=true"
import script from "./InventarioItems.vue?vue&type=script&lang=js"
export * from "./InventarioItems.vue?vue&type=script&lang=js"
import style0 from "./InventarioItems.vue?vue&type=style&index=0&id=7fc0bfb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc0bfb9",
  null
  
)

export default component.exports